import { render, staticRenderFns } from "./Payements.vue?vue&type=template&id=86e10384&scoped=true&"
import script from "./Payements.vue?vue&type=script&lang=js&"
export * from "./Payements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e10384",
  null
  
)

export default component.exports